import { DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';

@Component({
  selector: 'app-bank-reco-in-brief-report',
  templateUrl: './bank-reco-in-brief-report.component.html',
  styleUrl: './bank-reco-in-brief-report.component.scss'
})
export class BankRecoInBriefReportComponent {

  currentDate: Date;
  startDate: any;
  endDate: any;
  bankType: any;
  bankRecoData: any;
  bankRecoData1: any;
  data1: any;
  category2_crApproved: any[] = [];
  category3_drApproved: any[] = [];
  category4_crPending: any[] = [];
  category5_drPending: any[] = [];
  category2Total: number = 0;
  category3Total: number = 0;
  category4Total: number = 0;
  category5Total: number = 0;
  cr_opening_bal: number = 0;
  dr_opening_bal: number = 0;
  openingBalance: number = 0;
  currentBalance: number = 0;
  drTotal: number = 0;
  crTotal: number = 0;
  cr_opening_bal1: number = 0;
  dr_opening_bal1: number = 0;

  debitList1: any;
  creditList1: any;
  debitList1Total: any;
  creditList1Total: any;
  debitList2: any;
  creditList2: any;
  debitList2Total: any;
  creditList2Total: any;
  bank: any;

  constructor(
    private datePipe: DatePipe,
    private dialogRef: MatDialogRef<BankRecoInBriefReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
  ) {

  }

  ngOnInit(): void {

    this.currentDate = new Date();
    this.startDate = this.data['startDate'];
    this.endDate = this.data['endDate'];
    this.bankType = this.data['bankType'];
    this.getBankRecoReport();
  }

  getBankRecoReport() {

    const startDate = new Date(this.startDate); // Replace with your dynamic value

    // Define range
    const startRange = new Date('2024-04-01');
    const endRange = new Date('2025-03-31');

    // Check if startDate is in range
    if (startDate >= startRange && startDate <= endRange) {
      this.service.getBankOpeningBalance(this.bankType).subscribe((response: any[]) => {
        response.forEach(item => {

          this.bank = item.sub_exp_name;

          if (item.status == 'Cr') {
            this.cr_opening_bal = +item.opening_bal;
          } else if (item.status == 'Dr') {
            this.dr_opening_bal = +item.opening_bal;
          }
          this.calculationMethod();
        });
      });
      console.log('Executing 1st block: Start date is within the range');
    } else {
      this.service.getBankOpeningBalance(this.bankType).subscribe((response: any[]) => {
        response.forEach(item => {

          this.bank = item.sub_exp_name;

          if (item.status == 'Cr') {
            this.cr_opening_bal1 = item.opening_bal;
          } else if (item.status == 'Dr') {
            this.dr_opening_bal1 = item.opening_bal;
          }

          this.CalculateCarryForwardOpening();
        });
      });
      console.log('Executing 2nd block: Start date is outside the range');
    }

  }

  calculationMethod() {
    this.service.getBankRecoReport1(this.startDate, this.endDate, this.bankType).subscribe((response1: any) => {

      this.bankRecoData1 = response1 as any[];

      this.service.getBankRecoReport(this.startDate, this.endDate, this.bankType).subscribe((response: any) => {

        this.bankRecoData = response as any[];


        debugger

        // Opening Balance = Credit - Debit
        this.openingBalance = (this.cr_opening_bal || 0) + (this.dr_opening_bal || 0);
        this.currentBalance = this.openingBalance;

        // Only approved transactions
        this.category2_crApproved = response1
          .filter(item => item.voucher_type === 'CR' && item.cheq_clearing_date !== '0000-00-00')
          .sort((a, b) => new Date(a.voucher_date).getTime() - new Date(b.voucher_date).getTime())
          .map(item => {
            if (this.bankType === 'JSBP' || this.bankType === 'JSBL' || this.bankType === 'TJSBOD') {

              // if (this.cr_opening_bal == 0) {
              //   this.currentBalance -= item.deposit_amt;
              // } else {
              //   this.currentBalance -= item.deposit_amt;
              // }

              this.currentBalance -= item.deposit_amt;

            } else {
              // if (this.cr_opening_bal == 0) {
              //   this.currentBalance -= item.deposit_amt;
              // } else {
              //   this.currentBalance += item.deposit_amt;
              // }

              this.currentBalance += item.deposit_amt;

            }
            return { ...item, running_balance: this.currentBalance };
          });

        this.category2Total = Math.abs(
          this.category2_crApproved.reduce((sum, item) => sum + (+item.deposit_amt || 0), 0)
        );


        this.category3_drApproved = response1
          .filter(item => item.voucher_type === 'DR' && item.cheq_clearing_date !== '0000-00-00')
          .sort((a, b) => new Date(a.voucher_date).getTime() - new Date(b.voucher_date).getTime())
          .map(item => {
            let amount = Math.abs(item.deposit_amt)
            if (this.bankType === 'JSBP' || this.bankType === 'JSBL' || this.bankType === 'TJSBOD') {
              // if (item.voucher_type === 'DR') {
              //   if (this.cr_opening_bal == 0) {
              //     this.currentBalance += amount;
              //   } else {
              //     this.currentBalance += amount;
              //   }
              // }

              this.currentBalance += amount;

            } else {

              // if (this.cr_opening_bal == 0) {
              //   this.currentBalance += amount;
              // } else {
              //   this.currentBalance -= amount;
              // }

              this.currentBalance -= amount;

            }
            return { ...item, running_balance: this.currentBalance };
          });

        this.category3Total = Math.abs(this.category3_drApproved.reduce(
          (sum, item) => sum + (+item.deposit_amt || 0), 0
        ));

        this.category4_crPending = response
          .filter(item => item.voucher_type === 'CR' && item.cheq_clearing_date === '0000-00-00')
          .sort((a, b) => new Date(a.voucher_date).getTime() - new Date(b.voucher_date).getTime())
          .map(item => {
            if (this.bankType === 'JSBP' || this.bankType === 'JSBL' || this.bankType === 'TJSBOD') {
              // if (item.voucher_type === 'CR') {
              //   if (this.cr_opening_bal == 0) {
              //     this.currentBalance -= item.deposit_amt;
              //   } else {
              //     this.currentBalance -= item.deposit_amt;
              //   }
              // }

              this.currentBalance -= item.deposit_amt;

            } else {

              // if (this.cr_opening_bal == 0) {
              //   this.currentBalance -= item.deposit_amt;
              // } else {
              //   this.currentBalance += item.deposit_amt;
              // }

              this.currentBalance += item.deposit_amt;

            }
            return { ...item, running_balance: this.currentBalance };
          });

        this.category4Total = Math.abs(this.category4_crPending.reduce(
          (sum, item) => sum + (+item.deposit_amt || 0), 0
        ));

        this.category5_drPending = response
          .filter(item => item.voucher_type === 'DR' && item.cheq_clearing_date === '0000-00-00')
          .sort((a, b) => new Date(a.voucher_date).getTime() - new Date(b.voucher_date).getTime())
          .map(item => {
            let amount = Math.abs(item.deposit_amt)
            if (this.bankType === 'JSBP' || this.bankType === 'JSBL' || this.bankType === 'TJSBOD') {
              // if (item.voucher_type === 'DR') {
              //   if (this.cr_opening_bal == 0) {
              //     this.currentBalance += amount;
              //   } else {
              //     this.currentBalance += amount;
              //   }
              // }

              this.currentBalance += amount;

            } else {

              // if (this.cr_opening_bal == 0) {
              //   this.currentBalance += amount;
              // } else {
              //   this.currentBalance -= amount;
              // }

              this.currentBalance -= amount;

            }
            return { ...item, running_balance: this.currentBalance };
          });

        this.category5Total = Math.abs(this.category5_drPending.reduce(
          (sum, item) => sum + (+item.deposit_amt || 0), 0
        ));

        this.calTotal();

      });


    });
  }

  CalculateCarryForwardOpening() {

    const inputStartDate = new Date(this.startDate); // Example input

    // Fixed start date (as per your requirement)
    const newStartDate = new Date('2024-04-01');

    // Extract year and month
    const inputYear = inputStartDate.getFullYear();
    const inputMonth = inputStartDate.getMonth(); // 0 = Jan, 2 = Mar, 3 = Apr...

    // Determine which financial year the date falls in
    // Then subtract one year to get the previous FY's March 31
    const financialYearStart = inputMonth <= 2 ? inputYear - 1 : inputYear;
    const newEndDate = new Date(financialYearStart, 2, 31); // March = 2

    const formatDate = (date: Date): string => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // month is 0-indexed
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const formattedStartDate = formatDate(newStartDate);
    const formattedEndDate = formatDate(newEndDate);

    // Output
    console.log('newStartDate:', newStartDate.toISOString().slice(0, 10));
    console.log('newEndDate:', newEndDate.toISOString().slice(0, 10));

    this.service.getBankRecoReport1(formattedStartDate, formattedEndDate, this.bankType).subscribe((response1: any) => {

      this.bankRecoData1 = response1 as any[];

      this.service.getBankRecoReport(formattedStartDate, formattedEndDate, this.bankType).subscribe((response: any) => {

        this.bankRecoData = response as any[];

        this.debitList1 = response1.filter(
          item => item.voucher_type === 'CR' && item.cheq_clearing_date !== '0000-00-00'
        );

        this.creditList1 = response1.filter(
          item => item.voucher_type === 'DR' && item.cheq_clearing_date !== '0000-00-00'
        );

        this.debitList2 = response.filter(
          item => item.voucher_type === 'CR' && item.cheq_clearing_date === '0000-00-00'
        );

        this.creditList2 = response.filter(
          item => item.voucher_type === 'DR' && item.cheq_clearing_date === '0000-00-00'
        );

        this.debitList1Total = this.debitList1.reduce(
          (sum, item) => sum + (+item.deposit_amt || 0), 0
        );

        this.creditList1Total = this.creditList1.reduce(
          (sum, item) => sum + Math.abs(+item.deposit_amt || 0), 0
        );

        this.debitList2Total = this.debitList2.reduce(
          (sum, item) => sum + (+item.deposit_amt || 0), 0
        );

        this.creditList2Total = this.creditList2.reduce(
          (sum, item) => sum + Math.abs(+item.deposit_amt || 0), 0
        );

        const creditTotal = this.creditList1Total + this.creditList2Total;
        const debitTotal = this.debitList1Total + this.debitList2Total;

        const finalBalance = (Number(this.cr_opening_bal1) + Number(creditTotal)) - (Number(+this.dr_opening_bal1) + Number(debitTotal))

        debugger

        if (finalBalance >= 0) {
          this.cr_opening_bal = Number(finalBalance);
          this.dr_opening_bal = 0;
        } else {
          this.dr_opening_bal = Math.abs(finalBalance);
          this.cr_opening_bal = 0;
        }

        this.calculationMethod();

      });

    });
  }

  calTotal() {
    this.crTotal = this.cr_opening_bal + this.category3Total + this.category5Total;
    this.drTotal = Math.abs(this.dr_opening_bal) + this.category2Total + this.category4Total;
  }

  lastRunningBalance2: number = 0;

  setLastRunningBalance2(balance: number): string {
    this.lastRunningBalance2 = balance;
    this.currentBalance = this.lastRunningBalance2;
    return ''; // to avoid rendering anything in the DOM
  }

  lastRunningBalance3: number = 0;

  setLastRunningBalance3(balance: number): string {
    this.lastRunningBalance3 = balance;
    this.currentBalance = this.lastRunningBalance3;
    return ''; // to avoid rendering anything in the DOM
  }

  lastRunningBalance4: number = 0;

  setLastRunningBalance4(balance: number): string {
    this.lastRunningBalance4 = balance;
    this.currentBalance = this.lastRunningBalance4;
    return ''; // to avoid rendering anything in the DOM
  }

  lastRunningBalance5: number = 0;

  setLastRunningBalance5(balance: number): string {
    this.lastRunningBalance5 = balance;
    this.currentBalance = this.lastRunningBalance5;
    return ''; // to avoid rendering anything in the DOM
  }

  getFormattedDate(): string {
    return this.datePipe.transform(this.currentDate, 'dd-MM-yyyy');
  }

  // Checks if the bank requires inverted Cr/Dr logic
  isInvertedBank(): boolean {
    return this.bankType === 'JSBP' || this.bankType === 'JSBL' || this.bankType === 'TJSBOD';
  }

  // Determines if the balance is Cr or Dr based on bank type
  getBalanceLabel(amount: number): string {
    debugger
    if (this.isInvertedBank()) {
      return amount < 0 ? 'Dr' : 'Cr';
    } else {
      return amount < 0 ? 'Cr' : 'Dr';
    }
  }

  // Provides the absolute value for display if needed
  getAbsoluteBalance(amount: number): number {
    return Math.abs(amount);
  }

}